import * as React from 'react';

import { FDealType } from '../../../../../JsonQuery';
import { DealType } from '../../../components/filters/DealType';
import { IFilterComponentProps } from '../../../types/filters';
import { TAvailableModifierActions } from '../../../types/modifier';
import { useSearchResultsTooltipOpen } from '../../../utils/searchResultsTooltipOpen';
import { useContext } from '../../../utils/useContext';
import { useDealType } from '../../../utils/useDealType';

export const DealTypeContainer: React.FC<IFilterComponentProps> = ({ filterKey, open, onOpen, onClose }) => {
  const { onChange, jsonQueryCount, jsonQueryCountRefreshing, onApply, onApplyClick } = useContext();
  const dealType = useDealType();
  const action: TAvailableModifierActions = 'setDealType';
  const openTooltip = useSearchResultsTooltipOpen({ filterKey, actions: [action] });

  const handleApply = React.useCallback(() => {
    if (onApplyClick) {
      onApplyClick({ source: 'tooltip' });
    }

    onApply();
  }, [onApply, onApplyClick]);

  const handleChange = React.useCallback(
    (dealType: FDealType) => {
      onChange({ action, arguments: [dealType] });
    },
    [onChange],
  );

  return (
    <DealType
      open={open}
      value={dealType}
      offersCount={jsonQueryCount}
      offersCountLoading={jsonQueryCountRefreshing}
      openTooltip={openTooltip}
      onChange={handleChange}
      onApply={handleApply}
      onOpen={onOpen}
      onClose={onClose}
    />
  );
};
